import React from 'react'

import { reportListCellData, reportListData } from '../@signals'
import { reportSearchesModalId } from '@signals'
import { AppReportSearchesModal } from '@components'


export default function ReportListSearchSummaryModal() {

	if (!reportSearchesModalId.value) return null

	// the same counts the row shows next to its progress bar
	const { completeTasksString, totalTasksString } = reportListCellData.value[reportSearchesModalId.value] || {}
	const progressText = completeTasksString && totalTasksString ? `${completeTasksString} of ${totalTasksString} searches` : undefined

	return <AppReportSearchesModal data={reportListData.value} progressText={progressText}/>
}
